import { render, staticRenderFns } from "./devops-extra-actions.vue?vue&type=template&id=051276d8&scoped=true"
import script from "./devops-extra-actions.vue?vue&type=script&lang=js"
export * from "./devops-extra-actions.vue?vue&type=script&lang=js"
import style0 from "./devops-extra-actions.vue?vue&type=style&index=0&id=051276d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051276d8",
  null
  
)

export default component.exports